import { RootSelector, getStore } from '../../reducers';
import { ColumnKey, LinkModal, SharingLinkShape } from './model';
import { createSelector } from '@reduxjs/toolkit';
import { SharingLink } from '../../api';
import { ColumnType } from '@myua/kit/dist/antd/table';
import { LinkRender } from './components/LinkRender';
import dayjs from 'dayjs';

export const getSharingLink: RootSelector<SharingLinkShape> = createSelector(
  getStore,
  (state) => state.sharingLink,
);

export const getSearchQuery = createSelector(
  getSharingLink,
  (sharingLink) => sharingLink.searchQuery,
);

export const getLinks: RootSelector<SharingLink[]> = createSelector(
  getSharingLink,
  (sharingLink) => sharingLink.links,
);

export const getLinksById: RootSelector<Partial<Record<SharingLink['id'], SharingLink>>> =
  createSelector(getLinks, (links) => {
    const result: Partial<Record<SharingLink['id'], SharingLink>> = {};
    links.forEach((link) => {
      result[link.id] = link;
    });
    return result;
  });

export const getLoading: RootSelector<boolean> = createSelector(
  getSharingLink,
  (sharingLink) => sharingLink.loading,
);

export const getLinkModal: RootSelector<LinkModal> = createSelector(
  getSharingLink,
  (sharingLink) => sharingLink.linkModal,
);

export const getSelectedIds: RootSelector<SharingLink['id'][]> = createSelector(
  getSharingLink,
  (sharingLink) => sharingLink.selectedIds,
);

export const getSorter = createSelector(getSharingLink, (sharingLink) => sharingLink.sorter);

export const getPagination = createSelector(
  getSharingLink,
  (sharingLink) => sharingLink.pagination,
);

export const getIsActiveFilter = createSelector(
  getSharingLink,
  (sharingLink) => sharingLink.isActiveFilter,
);

export const getColumns = createSelector(getSorter, getIsActiveFilter, (sorter, isActiveFilter) => {
  const columns: ColumnType<SharingLink>[] = [
    {
      title: 'Name',
      key: ColumnKey.name,
      dataIndex: 'name',
      width: 300,
      sorter: true,
    },
    {
      title: 'Link',
      key: ColumnKey.link,
      render: LinkRender,
    },
    {
      title: 'Created date',
      key: ColumnKey.created_at,
      dataIndex: 'created_at',
      width: 140,
      sorter: true,
      render: (value: SharingLink['created_at']) => dayjs(value).format('YYYY-MM-DD'),
    },
    {
      title: 'Active',
      key: ColumnKey.is_active,
      dataIndex: 'is_active',
      width: 100,
      sorter: true,
      // Фильтр серверный: выбранное значение уходит в API как is_active, пагинация и
      // total считаются на бэке. filteredValue контролируется из стора (MYUA-16466).
      filters: [
        { text: 'yes', value: true },
        { text: 'no', value: false },
      ],
      filterMultiple: false,
      filteredValue: isActiveFilter === undefined ? null : [isActiveFilter],
      render: (value: SharingLink['is_active']) => (value ? 'yes' : 'no'),
    },
    {
      title: 'Author',
      key: ColumnKey.email,
      dataIndex: 'email',
      width: 300,
      sorter: true,
    },
  ].map((column) => ({
    ...column,
    sortOrder: column.key === sorter.columnKey ? sorter.order : undefined,
  }));

  return columns;
});
